<!--订单详情 高春超 2018年2月7日15:41:55-->
<style scoped>
.orderInfo {
  float: left;
  position: relative;
  z-index: 1;
  top: 0;
}

.orderInfo .top {
  width: 753px;
  height: 8px;
  background: url(//static.kxymall.com/images/hylyt.jpg) no-repeat left
    top;
  overflow: hidden;
}

.orderInfo .order_detail_wrapper {
  border-left: 1px solid #dbdbdb;
  border-right: 1px solid #dbdbdb;
  background-color: #ffffff;
  width: 751px;
}

.orderInfo .order_detail_wrapper .title {
  height: 40px;
  background-color: #eee;
  border-bottom: 1px solid #d2dcdb;
  overflow: hidden;
}

.orderInfo .order_detail_wrapper .title h1 {
  background-color: transparent;
  float: left;
  display: inline;
  margin: 0 15px 0 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: normal;
  color: #6c6c6c;
}

.orderInfo .order_detail_wrapper .title h1 span {
  margin: 0 5px;
  font-weight: bold;
  color: #000;
}

.orderInfo .order_detail_wrapper .title h2 {
  float: left;
  display: inline;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: normal;
  color: #6c6c6c;
}

.orderInfo .order_detail_wrapper .title h2 span {
  margin: 0 5px;
  font-weight: bold;
  color: #000;
}

/**订单日志**/
.orderInfo .order_detail_wrapper .log ol {
  overflow: hidden;
  background-color: #fff;
  padding-left: 67px;
}

.orderInfo .order_detail_wrapper .log ol li {
  float: left;
  display: inline;
  width: 686px;
  line-height: 25px;
}

/**收货人信息**/
.orderInfo .order_detail_wrapper .receiver {
  overflow: hidden;
  padding: 30px 0px;
  background-color: #fff;
}

.orderInfo .order_detail_wrapper .receiver table {
  border: 0 none;
}

.orderInfo .order_detail_wrapper .receiver table tr th {
  padding: 5px 0;
  width: 18%;
  background-color: #fff;
  text-align: right;
  border: 0 none;
  vertical-align: top;
}

.orderInfo .order_detail_wrapper .receiver table tr td {
  padding: 5px 0 5px 26px;
  border: 0 none;
  text-align: left;
}

.orderInfo .order_detail_wrapper .receiver table tr td ul {
  width: 100%;
}

.orderInfo .order_detail_wrapper .receiver table tr td ul li {
  line-height: 25px;
  height: 25px;
}

.orderInfo .order_detail_wrapper .receiver table tr td ul li label {
  margin-right: 10px;
}

.orderInfo .order_detail_wrapper .goodslist {
  padding: 0 10px;
}

.orderInfo .order_detail_wrapper .goodslist td {
  border-bottom: 1px dotted #dbdbdb;
}

.orderInfo .order_detail_wrapper h1 {
  color: #333;
  height: 38px;
  line-height: 38px;
  background-color: #fff;
  padding-left: 0;
}

.orderInfo .goodslist table .hovertr td {
  padding: 10px 0;
}

.orderInfo .goodslist table th {
  height: 31px;
  line-height: 31px;
  border-bottom: 1px solid #dbdbdb;
  background-color: #eee;
  text-align: center;
}

.orderInfo .goodslist table .last td {
  border: 0px none;
}

.orderInfo .goodslist table td {
  border-bottom: 1px dotted #dbdbdb;
  height: 31px;
  line-height: 31px;
  text-align: center;
  background-color: #fff;
}

.orderInfo .order_detail_wrapper .total {
  clear: both;
  overflow: hidden;
  background-color: #fff;
}

.orderInfo .order_detail_wrapper .total table {
  width: 210px;
  float: right;
  border: 0 none;
}

.orderInfo .order_detail_wrapper .total table tr th {
  height: 25px;
  line-height: 25px;
  border: 0px none;
  width: 100px;
  text-align: right;
  padding-right: 10px;
  background-color: #fff;
  font-weight: normal;
}

.orderInfo .order_detail_wrapper .total table tr td {
  text-align: left;
  border: 0 none;
  height: 25px;
  line-height: 25px;
}

.orderInfo .order_detail_wrapper .total table tr .discount_green {
  color: #13ba2c;
}

.orderInfo .order_detail_wrapper .total table tr .already_money {
  color: #dd5d3a;
  font-size: 16px;
}
</style>
<template>
  <div class="crew_right" ref="content_wrapper">
    <div class="conInner">
      <div class="orderInfo">
        <div class="order_detail_wrapper" style="width:1000px;overflow: auto">
          <!-- 订单号、订单状态 -->
          <div class="title">
            <h1>订单号：<span>{{info.sn}}</span></h1>
            <h2>订单状态:<span>{{info.statusText}}</span></h2>
            <div class="order_invoice">
            </div>
          </div>
          <div class="receiver">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tbody>
                <tr>
                  <th>收货人信息</th>
                  <td>
                    <div><label>收货地址:</label> <span>{{info.shipping_area}}</span></div>
                    <div><label>收货人:</label> <span>{{info.ship_name}}</span></div>
                    <div v-if="info.ship_mobile!==''"><label>手机:</label> <span>{{info.ship_mobile}}</span></div>
                    <div v-if="info.ship_tel!==''"><label>联系电话:</label> <span>{{info.ship_tel}}</span></div>
                    <div><label>邮编:</label> <span>{{info.ship_zip}}</span></div>
                  </td>
                </tr>
                <tr>
                  <th>配送方式:</th>
                  <td>{{info.shipping_type}}</td>
                </tr>
                <tr>
                  <th>付款方式:</th>
                  <td>{{info.payment_name}}</td>
                </tr>
                <tr>
                  <th>订单附言:</th>
                  <td>{{info.remark}}</td>
                </tr>
                <tr>
                  <th>送货时间:</th>
                  <td>{{info.ship_day}}&nbsp;{{info.ship_time}}</td>
                </tr>
                <tr>
                  <th>发票抬头:</th>
                  <td>{{info.receipt.title}}</td>
                </tr>
                <tr>
                  <th>发票内容:</th>
                  <td>{{info.receipt.content}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="goodslist">
            <h1>商品清单</h1>
            <table cellspacing="0" cellpadding="0" width="100%">
              <thead>
                <tr>
                  <th>商品编号</th>
                  <th>商品名称</th>
                  <th>价格</th>
                  <th>数量</th>
                  <th>小计</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in info.items">
                  <td>
                    {{item.sn}}
                  </td>
                  <td>
                    <router-link :to="{path:'/goods',query:{goods_id:item.goods_id}}" target="_blank" class="link blue">
                      {{item.name}}
                    </router-link>
                  </td>
                  <td>￥{{item.price.toFixed(2)}}</td>
                  <td>{{item.num}}</td>
                  <td>￥{{(item.num * item.price).toFixed(2)}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="total">
            <table cellspacing="0" cellpadding="0" border="0" width="100%">
              <tbody>
                <tr>
                  <th>商品总金额:</th>
                  <td>￥{{info.order_amount.toFixed(2)}}</td>
                </tr>
                <tr>
                  <th>配送费用:</th>
                  <td>￥{{info.shipping_amount.toFixed(2)}}</td>
                </tr>
                <tr>
                  <th>优惠金额:</th>
                  <td class="discount_green">￥{{info.discount ? info.discount.toFixed(2) : 0}}</td>
                </tr>
                <tr>
                  <th>订单总金额:</th>
                  <td>￥{{info.order_amount.toFixed(2)}}</td>
                </tr>
                <tr>
                  <th>已付金额:</th>
                  <td class="already_money">￥{{info.paymoney.toFixed(2)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="height:30px;clear:both"> </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOrderDetailBySn } from 'api/order';
import message from 'utils/message';

export default {
  data() {
    return {
      ordersn: this.$route.query.ordersn,
      info: {
        sn: '', // 订单编号
        status: '', // 订单状态
        statusText: '', // 订单状态文字
        ship_name: '', // 收货人
        shipping_area: '', // 收货地址
        ship_mobile: '', // 收货人手机
        ship_tel: '', // 收货电话
        ship_zip: '', // 配送邮政编码
        shipping_type: '', // 配送方式
        payment_name: '', // 支付方式
        remark: '', // 订单附言
        ship_day: '', // 配送日期
        ship_time: '', // 配送时间
        items: [], // 订单明细
        receipt: {
          title: '无', // 	发票抬头
          content: '无' // 发票内容
        },
        goods_amount: 0, // 商品金额
        order_amount: 0, // 订单总金额
        shipping_amount: 0, // 配送费用
        discount: 0, // 订单优惠金额
        paymoney: 0, // 	已支付金额
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getOrderDetail();
      message.send(window.parent, 700);
    })
  },
  methods: {
    // 查看订单详细
    getOrderDetail() {
      getOrderDetailBySn({ orderNo: this.ordersn }).then(resp => {
        if (resp.resCode === 1) {
          console.log(resp.data)
          this.info = resp.data;
          if (!this.info.remark || this.info.remark === 'undefined') this.info.remark = '';
          if (resp.data.receipt === null) {
            this.info.receipt = {
              title: '无', // 	发票抬头
              content: '无' // 发票内容
            }
          }
        } else {
          this.$Message.success("查看订单失败!");
          setTimeout(() => {
            this.$router.push({
              path: '/member/order'
            })
          }, 500)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// orderdetailForPayment.vue?d17e7f76